"use client";

import { CoverageBar } from "./CoverageBar";
import { CoverageSwatch } from "./CoverageLegend";
import {
  COVERAGE_LABEL,
  COVERAGE_STATES,
  type CoverageCounts,
  describeCoverage,
} from "./coverage";
import { HoverPopover } from "./HoverPopover";

export interface CoverageMeterProps {
  coverage: CoverageCounts;
}

/**
 * A card's coverage bar that breaks the step counts down on hover or focus.
 * It sits above a card's stretched link, so the hover lands on the bar.
 */
export function CoverageMeter({ coverage }: CoverageMeterProps) {
  return (
    <HoverPopover
      label={`Step coverage: ${describeCoverage(coverage)}`}
      trigger={<CoverageBar coverage={coverage} size="md" labelled={false} />}
      triggerClassName="relative z-10 block w-full rounded-full"
      className="w-[216px] p-3"
    >
      <p className="text-[11.5px] font-semibold text-(--fg-primary)!">
        Step coverage
      </p>
      <ul className="mt-1.5 flex flex-col gap-1">
        {COVERAGE_STATES.map((state) => (
          <li
            key={state}
            className="flex items-center gap-1.5 text-[11px] text-(--fg-secondary)"
          >
            <CoverageSwatch state={state} size="xs" />
            <span className="font-semibold tabular-nums text-(--fg-primary)">
              {coverage[state]}
            </span>
            {COVERAGE_LABEL[state]}
          </li>
        ))}
      </ul>
    </HoverPopover>
  );
}
